import homePageBanner from "../../apis/homePageBanner";

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await homePageBanner.create(payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  delete({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await homePageBanner.delete(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await homePageBanner.update(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAll({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await homePageBanner.getAll(payload);

        commit("GET_ALL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
